var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{key:_vm.$route.path}),_vm._l((_vm.$store.state.notification.list),function(n){return _c('Notification',{key:n.id,attrs:{"value":n}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }